/* Dansk katalog for locale-pension-invoice-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'otp.sourceRequired': 'Dokument fra indbakken eller eksisterende bilag',
  'otp.positivePremium': 'Pensionspræmie større end 0 kr',
  'otp.completeBeforePreview': 'Udfyld eller vælg, før du viser konteringsforslaget:',
  'otp.unlinked': 'Lønhensættelser uden fakturakobling',
  'otp.alreadyPosted': 'Allerede bogført omkostning og betaling',
  'otp.noAccruals': 'Ingen tilgængelige lønhensættelser. Allerede betalte hensættelser skal korrigeres, før de kan knyttes til en faktura.',
  'otp.inboxNotice': 'Dette ligner en pensionsfaktura (OTP). Registrér den via Pension/OTP for at afregne mod lønhensættelser og håndtere arbejdsgiverafgiften korrekt.',
  'otp.open': 'Åbn i Pension/OTP',
  'otp.dismiss': 'Dette gælder ikke OTP',
  'otp.invoices': 'Pensionsfakturaer og afregning',
  'otp.register': 'Registrér pensionsfaktura',
  'otp.flow': 'Knyt fakturaen til lønhensættelserne først. Betaling registreres på fakturaen én gang. Arbejdsgiverafgiften følger den faktiske betalingsmåned.',
  'otp.invoice': 'Faktura',
  'otp.actual': 'Faktisk omkostning',
  'otp.accrued': 'Afregnet hensættelse',
  'otp.paid': 'Betalt',
  'otp.remaining': 'Resterer',
  'otp.aga': 'Arbejdsgiverafgift behandlet',
  'otp.reported': 'Indberetning registreret',
  'otp.notReported': 'Indberetning ikke registreret',
  'otp.reportingReview': 'A-melding skal gennemgås',
  'otp.reportingWarning': 'Der er allerede registreret en A-melding for betalingsmåneden. Betalingen kan registreres, men du skal gennemgå og eventuelt korrigere A-meldingen med opdateret pensions- og arbejdsgiverafgiftsgrundlag. Tidligere indsendelse ændres ikke automatisk.',
  'otp.annulled': 'Kobling annulleret',
  'otp.details': 'Se detaljer',
  'otp.document': 'Dokument fra indbakken',
  'otp.existing': 'Knyt til eksisterende bilag',
  'otp.supplierName': 'Leverandør',
  'otp.invoiceNumber': 'Fakturanummer',
  'otp.invoiceDate': 'Fakturadato',
  'otp.dueDate': 'Forfaldsdato',
  'otp.date': 'Afregningsdato',
  'otp.premium': 'Arbejdsgivers pensionspræmie',
  'otp.administration': 'Pensionsadministration (uden moms)',
  'otp.components': 'Bekræft, at beløbene gælder arbejdsgivers præmie og eventuel administration af pensionsordningen, uden moms. Medarbejderandel, flyttegebyrer og andre komponenter skal afklares separat, før dette flow bruges.',
  'otp.selectAccruals': 'Vælg de lønhensættelser, fakturaen gælder',
  'otp.preview': 'Vis konteringsforslag',
  'otp.difference': 'Difference fra hensættelsen',
  'otp.existingPreview': 'Eksisterende køb og betaling bevares. Nedenfor vises kun afregning og eventuel omklassificering. Positivt beløb er debet, negativt er kredit.',
  'otp.newPreview': 'Fakturaen bogføres på 5950 mod leverandørgæld 2400. Nedenfor vises afregningen af tidligere hensættelser. Positivt beløb er debet, negativt er kredit. Betaling registreres separat.',
  'otp.confirm': 'Bekræft faktura og afregning',
  'otp.saved': 'OTP-registreringen er gemt.',
  'otp.purchasePosting': 'Se købsbilag',
  'otp.allocationPosting': 'Se afregning',
  'otp.paymentDocumented': 'Registrér kun en dokumenteret betaling, der ikke allerede er bogført. Dette udfører ingen bankoverførsel.',
  'otp.reversePayment': 'Annuller betaling',
  'otp.annulLink': 'Annuller afregning',
  'otp.annulExplanation': 'Afregningen og tilknyttet arbejdsgiverafgift modposteres. Købsfakturaen og betalingen bevares. Knyt fakturaen igen med de rigtige hensættelser bagefter. Dette ændrer ingen bankoverførsel.',
});
